import { render, staticRenderFns } from "./FlockHealthScore.vue?vue&type=template&id=707bd9e6&scoped=true&"
import script from "./FlockHealthScore.vue?vue&type=script&lang=js&"
export * from "./FlockHealthScore.vue?vue&type=script&lang=js&"
import style0 from "./FlockHealthScore.vue?vue&type=style&index=0&id=707bd9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bd9e6",
  null
  
)

export default component.exports